module.exports = __webpack_public_path__ + "static/media/Mutisunge Zulu.74422aa4.jpg";